"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.childProcess = void 0;
const child_process_1 = require("child_process");
exports.childProcess = {
    /**
     * 执行命令并把输出内容实时显示到终端（保持原样）
     * @param cmd 命令
     * @param dir 运行命令的目录
     * @returns 命令执行结束返回状态码
     */
    runCmdLive(cmd, dir = process.cwd()) {
        return new Promise(resolve => {
            const cp = (0, child_process_1.spawn)(cmd, {
                cwd: dir,
                stdio: 'inherit', // 将子进程的输出实时流式打印到终端
                shell: true,
            });
            cp.on('close', code => {
                resolve(code ?? 0);
            });
        });
    },
    /**
     * 同步执行命令，并获取命令结果字符串
     * @param cmd 命令
     * @param dir 运行命令的目录
     * @returns 执行结果字符串
     */
    runCmdSync(cmd, dir = process.cwd()) {
        const cp = (0, child_process_1.spawnSync)(cmd, {
            cwd: dir,
            stdio: 'pipe',
            encoding: 'utf-8',
            shell: true,
        });
        const message = cp.stdout && cp.stdout.length > 0 ? cp.stdout : cp.stderr || '';
        return message.toString().trim();
    },
    /**
     * 异步执行命令，并获取命令结果
     * @param cmd 命令
     * @param dir 运行命令的目录
     * @returns Promise<CmdResult> 对象
     */
    runCmdAsync(cmd, dir = process.cwd()) {
        return new Promise(resolve => {
            const cp = (0, child_process_1.spawn)(cmd, {
                cwd: dir,
                stdio: 'pipe',
                shell: true,
            });
            let dataOk = '';
            let dataError = '';
            cp.stdout?.on('data', (data) => {
                dataOk += data.toString();
            });
            cp.stderr?.on('data', (data) => {
                dataError += data.toString();
            });
            cp.on('close', () => {
                const stdoutTrimmed = dataOk.trim();
                const stderrTrimmed = dataError.trim();
                resolve({
                    status: stdoutTrimmed.length !== 0 ? 'success' : 'error',
                    data: stdoutTrimmed.length !== 0 ? stdoutTrimmed : stderrTrimmed,
                });
            });
        });
    },
    /**
     * 在新的控制台窗口中执行任务
     * @param task 命令
     * @param dir 运行命令的目录
     * @param autoClose 执行完毕后控制台窗口是否自动关闭（仅Windows系统支持）
     */
    runCmdNewWindow(task, dir = process.cwd(), autoClose = true) {
        let cmd = '';
        const platform = process.platform;
        if (platform === 'win32') {
            // Windows 系统：利用 start 打开独立 cmd 窗口，/c 表示执行完关闭，/k 表示执行完保留
            cmd = autoClose
                ? `start cmd /c "cd /d ${dir} && ${task}"`
                : `start cmd /k "cd /d ${dir} && ${task}"`;
        }
        else if (platform === 'darwin') {
            // macOS 系统：利用 osascript 调用系统自带的 Terminal.app
            cmd = `osascript -e 'tell application "Terminal" to do script "cd \\"${dir}\\" && ${task}"'`;
        }
        else {
            // Linux 系统：调用 gnome-terminal 打开新窗口
            cmd = `gnome-terminal -- bash -c "cd '${dir}' && ${task}; exec bash"`;
        }
        (0, child_process_1.spawn)(cmd, {
            cwd: dir,
            stdio: 'ignore',
            shell: true,
            detached: true,
            windowsHide: true,
        });
    },
};
exports.default = exports.childProcess;
